import { Suspense, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./pages/MAIN ROUTES/AppRoutes";
import AppLayout from "./pages/MAIN ROUTES/AppLayout";
import LoadingSpinner from "./components/common/LoadingSpinner";
import { ToastProvider } from "./context/ToastContext";
import { loadClarity } from "./utils/loadClarity";
import ScrollToTop from "./components/Accessories/ScrollToTop";
import { EventRequirementProvider } from "./context/EventRequirementContext";
import { ChatProvider } from "./context/ChatContext";
import EventWizard from "./components/event/RequirementPosting/index";
import FloatingChatContainer from "./components/Chat/FloatingChatContainer";

const App = () => {
  useEffect(() => {
    loadClarity();
  }, []);

  return (
    <EventRequirementProvider>
      <ToastProvider>
        <Router>
          <ChatProvider>
            <ScrollToTop />
            <AppLayout>
              <Suspense fallback={<LoadingSpinner />}>
                <AppRoutes />
              </Suspense>
              <EventWizard />
            </AppLayout>
            <FloatingChatContainer />
          </ChatProvider>
        </Router>
      </ToastProvider>
    </EventRequirementProvider>
  );
};

export default App;
